import { Box } from '@mui/material';
import {
  CompanyEarningsTab,
  CompanyFinancialsTab,
  CompanySentimentTab,
  CompanySnapShotTab,
  StockTickerList
} from 'modules';

import { ActivityDetailMultitabBase } from 'modules/components/layer50';



export type CompanyDetailMultitabProps = {
};

export const FC = () => {
  const tabs: ActivityDetailMultitabBase.MultitabOptions = [
    {
      label: 'Company Snapshot',
      value: 0,
      tab: (
        <CompanySnapShotTab.FC />
      )
    },
    {
      label: 'EPS & REVENUE',
      value: 1,
      tab: (
        <CompanyEarningsTab.FC />
      )
    },
    // {
    //   label: 'Relative valuation',
    //   value: 2,
    //   tab: (
    //     <CompanyValuationTab.FC listedCompanyId={props.listedCompanyId} />
    //   )
    // },
    {
      label: 'Financials & Ratios',
      value: 3,
      tab: (
        <CompanyFinancialsTab.FC />
      )
    },
    {
      label: 'Sentiment',
      value: 4,
      tab: (
        <CompanySentimentTab.FC />
      )
    }
  ];

  return (
    <Box
      flex='1 1 0'
      display='flex'
      flexDirection='row'
      paddingX='1.5rem'
      alignItems='stretch'
      height='100%'
    >
      <StockTickerList.FC />

      <Box
        flex='1 1 0'
        paddingX='1.5rem'
        paddingY='1rem'
        overflow='scroll'
      >
        <ActivityDetailMultitabBase.FC
          tabArray={tabs}
        />
      </Box>
    </Box>
  );
};
